import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RewardsWalletService, ScreenType } from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-auction-bid-details-page',
  templateUrl: './auction-bid-details-page.component.html',
  styleUrls: ['./auction-bid-details-page.component.scss'],
})
export class AuctionBidDetailsPageComponent implements OnInit {
  constructor(private route: ActivatedRoute, private rewardsWalletService: RewardsWalletService) {}
  id: number;
  screenSize = ScreenType;

  ngOnInit() {
    this.id = +(this.route.snapshot.paramMap.get('id') || 0);
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
  }
}
